import React from 'react';

import { WithAlloySuspense } from '@adsk/alloy-react-suspense';
import { StylableComponent } from '@adsk/alloy-react-theme';

import useUserSubscriptions from './hooks/useUserSubscriptions';
import SubscriptionsModalView from './SubscriptionsModalView';

type SubscriptionsModalProps = StylableComponent<HTMLDivElement> & {
  onCloseModal: () => void;
};
/**
 * A SubscriptionsModal
 * A Subscriptions Modal allows to show messages about subscriptions of the user.
 */

const SubscriptionsModal = React.forwardRef<
  HTMLDivElement,
  SubscriptionsModalProps
>(({ onCloseModal, ...props }, ref) => {
  const { subscriptions, error, isLoading, refetch } = useUserSubscriptions();

  return (
    <SubscriptionsModalView
      onCloseModal={onCloseModal}
      error={error}
      ref={ref}
      subscriptions={subscriptions}
      isLoading={isLoading}
      refetch={refetch}
      {...props}
    />
  );
});

SubscriptionsModal.displayName = 'SubscriptionsModal';

export default WithAlloySuspense(SubscriptionsModal);
